import {Dispatch} from "redux";
import {setMeAction} from "../../../app/setMe/actions";
import {ApplyOfferDto} from "../../../models/dtos/applyOffer.dto";
import {ErrorDto, getErrorDtoFromApiError} from "../../../models/dtos/error.dto";
import {OfferType} from "../../../models/enums/offerType";
import {OfferRequest} from "../../../models/requests/offer.request";
import {LocalStorage} from "../../../utilities/storage";
import {APPLY_OFFER_FAIL, APPLY_OFFER_RESET, APPLY_OFFER_START, APPLY_OFFER_SUCCESS,} from "./constants";
import {applyOfferRequest} from "./repository";
import {ApplyOfferFailAction, ApplyOfferResetAction, ApplyOfferStartAction, ApplyOfferSuccessAction,} from "./types";

const applyOfferStartAction = (): ApplyOfferStartAction => {
  return {
    type: APPLY_OFFER_START,
  };
}
const applyOfferSuccessAction = (payload: ApplyOfferDto): ApplyOfferSuccessAction => {
  return {
    type: APPLY_OFFER_SUCCESS,
    payload: payload,
  };
}
const applyOfferFailAction = (error: ErrorDto): ApplyOfferFailAction => {
  return {
    type: APPLY_OFFER_FAIL,
    error: error,
  };
}
const applyOfferResetAction = (): ApplyOfferResetAction => {
  return {
    type: APPLY_OFFER_RESET,
  };
}

export const applyOffer = (request: OfferRequest) => async (
  dispatch: Dispatch
) => {
  try {
    dispatch(applyOfferStartAction());
    const response = await applyOfferRequest(request);
    if (request.offerType === OfferType.GIVE_UP) {
      LocalStorage.set(LocalStorage.modalGiveUp, "true");
    }
    response.payment = {
      offerType: request.offerType,
      userLevel: response.level,
    }
    dispatch(setMeAction(response));
    dispatch(applyOfferSuccessAction(response));
  } catch (error) {
    dispatch(applyOfferFailAction(getErrorDtoFromApiError(error)));
  }
};

export const applyOfferReset = () => (
  dispatch: Dispatch
) => {
  dispatch(applyOfferResetAction());
};
